import { default as _RelativeTimeFormat } from "relative-time-format";
import en from "relative-time-format/locale/en.json";
import ja from "relative-time-format/locale/ja.json";
import ko from "relative-time-format/locale/ko.json";
import zh from "relative-time-format/locale/zh.json";

_RelativeTimeFormat.addLocale(en);
_RelativeTimeFormat.addLocale(ja);
_RelativeTimeFormat.addLocale(zh);
_RelativeTimeFormat.addLocale(ko);

export interface RelativeTimeFormatOptions {
  /**
   * The locale matching algorithm to use. Possible values are "lookup" and "best fit"
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#Locale_negotiation
   * @default "best fit"
   */
  localeMatcher?: "lookup" | "best fit";
  /**
   * "always" (1 day ago), "auto" (yesterday). The "auto" value allows to not always have to use numeric values in the output.
   * @default "always"
   */
  numeric?: "always" | "auto";
  /**
   * The length of the internationalized message.
   * - "long" (default, e.g., in 1 month)
   * - "short" (e.g., in 1 mo.),
   * - "narrow" (e.g., in 1 mo.). The narrow style could be similar to the short style for some locales.
   * @default "long"
   */
  style?: "long" | "short" | "narrow";
}
export const RelativeTimeFormat = (locale: string, options: object) => {
  const rtf = new _RelativeTimeFormat(locale, options);
  return rtf;
};
